// badUrl reproduces on reload (reads the query string); everything else re-derives from fresh server calls.
export type ErrorCause = 'badUrl' | 'recoverable'

// A dedicated class, not a string compare — ApiClient's ApiError takes its message verbatim from the backend.
export class BadUrlError extends Error {
  constructor() {
    super('Bad URL')
  }
}

export const deriveErrorCause = (e: unknown): ErrorCause =>
  e instanceof BadUrlError ? 'badUrl' : 'recoverable'

// Before the OAuth token exchange caches an access token, Reload just replays
// the same authCode/codeVerifier against it — a dead end if the code is
// single-use. hasAccessToken lets the caller check sessionStorage without this
// module reaching into it directly.
export const deriveBootstrapErrorCause = (
  e: unknown,
  hasAccessToken: boolean,
): ErrorCause => (hasAccessToken ? deriveErrorCause(e) : 'badUrl')
